require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/get-iterator.js
// module id = 214
// module chunks = 0